import { useRouteMatch, useQueryParams } from '@fs/zion-router'

import { getPreviewIdAndType } from '../lib/helpers/getPreviewIdAndTypeHelper'

export default function useBrightspotPreviewId(routeMatchPath) {
  const routeMatch = useRouteMatch(routeMatchPath)
  const { query } = useQueryParams()
  const { previewId } = getPreviewIdAndType(query)
  return previewId || routeMatch?.url
}
